/**
 * Локальная дата сообщения в виде YYYY-MM-DD — ключ группировки ленты по суткам.
 *
 * День считается в локальной таймзоне браузера — той же, в которой
 * MessageBubble показывает время сообщения. Форматтеры из `utils/date.ts` сюда
 * не годятся: они жёстко работают в Europe/Moscow (таймзона расписания уроков),
 * и у читателя из другого часового пояса плашка с датой разошлась бы с временем
 * в пузыре.
 *
 * Отдельный файл, а не экспорт из компонента: фаст-рефреш ломается, когда
 * модуль отдаёт и компонент, и функцию.
 */
export function localDayKey(iso: string | null): string | null {
  if (!iso) return null

  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null

  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${date.getFullYear()}-${month}-${day}`
}
